// import React, { useEffect, useState } from "react";
// import { CCard, CCardHeader, CCardBody, CSpinner } from "@coreui/react";
// import { appPageContents } from "../api/api";
// import "../TermsandCondition/TermsandCondition.css";
// const TermsandCondition = () => {
//   const [termsConditions, setTermsConditions] = useState("");
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     const fetchTermsAndConditions = async () => {
//       setLoading(true);
//       try {
//         const values = { page_type: "termsandconditions" };
//         const response = await appPageContents(values);
//         console.log("Terms and Conditions API Response:", response);

//         if (response?.content?.desc) {
//           const cleanText = response.content.desc
//             .replace(/<hr\s*\/?>/g, "")
//             .replace(/<[^>]*>/g, "")
//             .replace(/&nbsp;/g, " ")
//             .replace(/&amp;/g, "&")
//             .replace(/&lt;/g, "<")
//             .replace(/&gt;/g, ">");
//           setTermsConditions(cleanText);
//         }
//       } catch (error) {
//         console.error("Error fetching terms and conditions:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchTermsAndConditions();
//   }, []);

//   return (
//     <div className="terms-container">
//       <div className="containerall">
//         <CCard className="terms-card">
//           <CCardHeader className="terms-header">
//             Terms and Conditions
//           </CCardHeader>
//           <CCardBody className="terms-body">
//             {loading ? (
//               <div className="loader-container">
//                 <div className="custom-spinner"></div>
//               </div>
//             ) : (
//               <div className="terms-content">
//                 <p className="terms-text">{termsConditions}</p>
//               </div>
//             )}
//           </CCardBody>
//         </CCard>
//       </div>
//     </div>
//   );
// };

// export default TermsandCondition;

import React, { useEffect, useState } from "react";
import { appPageContents } from "../api/api";
import "../TermsandCondition/TermsandCondition.css";
import aboutbanners from "../../assets/images/about-head-banner.jpg";
import { FaChevronRight } from 'react-icons/fa';

const TermsandCondition = () => {
  const [termsConditions, setTermsConditions] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchTermsAndConditions = async () => {
      setLoading(true);
      try {
        const values = { page_type: "termsandconditions" };
        const response = await appPageContents(values);
        console.log("Terms and Conditions API Response:", response);

        if (response?.content?.desc) {
          const cleanText = response.content.desc
            .replace(/<hr\s*\/?>/g, "")
            .replace(/<[^>]*>/g, "")
            .replace(/&nbsp;/g, " ")
            .replace(/&amp;/g, "&")
            .replace(/&lt;/g, "<")
            .replace(/&gt;/g, ">");
          setTermsConditions(cleanText);
        }
      } catch (error) {
        console.error("Error fetching terms and conditions:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTermsAndConditions();
  }, []);

  return (
    <div className="registration-privacy-container">
      <div className="bannersec"
        style={{
          backgroundImage: `url(${aboutbanners})`,
        }}>
        <h4>Terms and Conditions</h4>
        <p>Home <span><FaChevronRight /></span> Terms and Conditions</p>

      </div>
      <div className="containerall">
        <div className="registration-privacy-card">
          <div className="registration-privacy-header">Terms and Conditions</div>
          <div className="registration-privacy-body">
            {loading ? (
              <div className="registration-privacy-loader-container">
                <div className="registration-custom-spinner"></div>
              </div>
            ) : (
              <div className="registration-privacy-content">
                <p className="registration-privacy-text">{termsConditions}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsandCondition;
